<template>
    <v-select
        :options="searchedProviders"
        class="provider-search"
        placeholder="Doctor name or specialty"
        @search="search"
        @input="goToProvider"
        :filterable="false"
    >
    <template slot="no-options">
        Type to search providers
    </template>
    <template #option="option">
        <div class="flex">
            <div class="image" :style="`background-image: url(${option.avatar})`"></div>
            <div class="text">
                <strong>{{ option.name }}</strong>
                <br />
                {{ option.specialty }}
            </div>
        </div>
    </template>
</v-select>
</template>

<script>
import {mapState} from 'vuex';
import VSelect from 'vue-select';

export default {
    components: {VSelect},

    computed: {
        ...mapState(['searchedProviders']),
    },

    data() {
        return {
            timer: undefined
        };
    },

    methods: {
        search(search) {
            clearTimeout(this.timer)

            this.timer = setTimeout(() => {
                this.$store.dispatch('getSearchedProviders', search);
            }, 1000)
        },

        goToProvider(provider) {
            const url = `/providers/${provider.id}/${provider.name_for_url}/`;
            window.open(url, '_blank');
        },
    },
};
</script>
